export default __webpack_public_path__ + "static/media/TransmitAppointment.62eff655.svg";